import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

import routes from '@/views'

export default new VueRouter({
    mode: 'history',
    routes: [
        ...routes,
        {
            path: '/*',
            redirect: '/home'
        },

    ]
})